<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="accessory.can_delete || accessory.can_update || mixinIsCanViewKPI || mixinIsCanCreateTodo || mixinIsCanCreateRequest || mixinIsCanViewAccessory"
		v-bind="$attrs"
		:class="['device-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'device-context-menu-list' }"
	>
		<div v-if="accessory.can_update" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', accessory)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div v-if="accessory.can_update" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickResetKpiHour', accessory)">
			<i class="nucleo mr-3 nucleo-folder-sync" />
			{{ $t("Actions.Reset") }}
		</div>

		<div v-if="accessory.can_delete" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', accessory)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import { kpiPermissions, todoPermissions, devicePermissions, requestPermissions, accessoryPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "DeviceKpiContextMenu",
	mixins: [
		getUserPermissions({
			...kpiPermissions,
			...todoPermissions,
			...devicePermissions,
			...requestPermissions,
			...accessoryPermissions
		})
	],
	components: { CbsContextMenu },
	props: {
		accessory: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {},
		onClickCreateTodo: {},
		onClickCreateRequest: {},
		onClickManageChecklist: {},
		onClickManageAccessories: {}
	}
};
</script>

<style lang="scss" scoped>
.device-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.device-context-menu-list {
	.device-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
